<template>
    <div class="popup__wrap">
        <div class="popup__title">
            {{ $t("translation.scanningForRobots") }}...
        </div>
        <div class="popup__scan">
            <div class="waiting">
                <div class="waiting__element"></div>
                <div class="waiting__element"></div>
                <div class="waiting__element"></div>
                <div class="waiting__element"></div>
                <div class="waiting__element"></div>
                <div class="waiting__element"></div>
                <div class="waiting__element"></div>
                <div class="waiting__element"></div>
                <div class="waiting__element"></div>
                <div class="waiting__element"></div>
                <div class="waiting__element"></div>
                <div class="waiting__element"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/pop-up/Scanning.vue